module.exports = RedNaoFormBuilder.default('FormBuilder/Events/LoadExtensionOptions');